import Overlay from 'ol/Overlay';
import Style from 'ol/style/Style';
import Icon from 'ol/style/Icon';
import h from 'hyperscript';
import mapMarker from '@disy/cadenza-icons/pointer-blue.svg';

export class WpsMarkerPopup extends Overlay {

  constructor (popupContentHtml, coordinate, options = {}) {
    super(Object.assign(options, { offset: [ 0, -20 ] }));
    const popupCloser = h('a.ol-overlay-closer', { onclick: (event) => { this.element.hidden = true; event.preventDefault(); } });
    this.popupContent = h('div.ol-overlay-content', { innerHTML: popupContentHtml });
    this.setPosition(coordinate);
    this.element.appendChild(h('div.ol-overlay.wps-marker-popup', [ popupCloser, this.popupContent ]));
  }

  show () {
    this.element.hidden = false;
  }

  hide () {
    this.element.hidden = true;
  }

}

export function getMarkersLayerStyle () {
  return [
    new Style({
      image: new Icon(({
        rotateWithView: false,
        anchor: [ 0.5, 1 ],
        anchorXUnits: 'fraction',
        anchorYUnits: 'fraction',
        opacity: 1,
        src: `data:image/svg+xml;base64,${btoa(mapMarker)}`, // base64 is required for IE
        size: [ 50, 50 ]
      }))
    })
  ];
}
